const product = [
    {
        img: "https://contextimages.vercel.app/images/Watches/featured1.png",
        label: "Jazzmaster",
        price: 1050,
        amount: 1,
    },
    {
        img: "https://contextimages.vercel.app/images/Watches/featured2.png",
        label: "Ingersoll",
        price: 250,
        amount: 1,
    },
    {
        img: "https://contextimages.vercel.app/images/Watches/featured3.png",
        label: "Rose gold",
        price: 850,
        amount: 1,
    },
];

export default product;